<div class="planner-page">
  @if (isWelcomeViewNeed) {
    <app-trip-planner-welcome></app-trip-planner-welcome>
  } @else {
    @if (!breakpointService.isMobile()) {
      <app-trip-planner-interaction
        [trip]="trip()"
        [tripState]="trip"
        [visibleTripId]="visibleTripId"
        (needToRefreshTripState)="needToRefreshTripStateHandler()"
      ></app-trip-planner-interaction>
    } @else {
      <app-mobile-trip-planner-interaction
        [trip]="trip()"
        [tripState]="trip"
        [visibleTripId]="visibleTripId"
        (needToRefreshTripState)="needToRefreshTripStateHandler()"
      ></app-mobile-trip-planner-interaction>
    }
  }
</div>
